import * as React from "react";
import {Navigate} from "react-router-dom";

import AppLayout from "Layout";
import {CUSTOM_DASHBOARD_PRIMOR_ROUTES} from '@constants/routes'
import FlashOffersPage from "./FlashOffers";


export const CustomDashboardPrimorRoutes = {
	path: CUSTOM_DASHBOARD_PRIMOR_ROUTES.PATH,
	title: CUSTOM_DASHBOARD_PRIMOR_ROUTES.TITLE,
	accessKey: CUSTOM_DASHBOARD_PRIMOR_ROUTES.ACCESS_KEY,
	icon: 'passport',
	description: "",
	element: <AppLayout />,
	children: [{
		element: <Navigate to={CUSTOM_DASHBOARD_PRIMOR_ROUTES.FLASH_OFFERS_PATH} replace />,  index: true
	}, {
		title: CUSTOM_DASHBOARD_PRIMOR_ROUTES.FLASH_OFFERS_TITLE,
		path: CUSTOM_DASHBOARD_PRIMOR_ROUTES.FLASH_OFFERS_PATH,
		dashboardKey: CUSTOM_DASHBOARD_PRIMOR_ROUTES.FLASH_OFFERS_ID,
		element: <FlashOffersPage />
	}]
}